import React from 'react'
import DefaultUserIcon from '../../../images/default_user_icon.jpg'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export default function OwnerDetail(props: {
  ownerName: string
  ownerIcon: string
  description: string
  doorId: string
  children?: React.ReactNode
  isPreview?: boolean
}) {
  const { ownerName, ownerIcon, description, doorId, children, isPreview } =
    props

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isPreview) {
      event.preventDefault()
    }
  }

  // @ts-ignore
  return (
    <DivWrap>
      <ScrollableDiv>
        <OwnerSection>
          <p className="owner-head-text">このサロンのオーナー</p>
          <div
            className="owner-image"
            style={{
              backgroundImage: `url(${ownerIcon ? ownerIcon : DefaultUserIcon})`
            }}
          />
          <h3 className="owner-name">{ownerName}</h3>
          <p className="owner-text">{description}</p>
          <SalonDetailButton
            to={`/door/${doorId}`}
            onClick={handleClick}
          >
            サロン詳細をみる
          </SalonDetailButton>
        </OwnerSection>
        {children}
      </ScrollableDiv>
    </DivWrap>
  )
}

const SalonDetailButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  background: #fff;
  border-radius: 48px;
  color: #26BFDB;
  font-size: 14px;
  font-weight: bold;
  &:hover {
    opacity: .9;
  }
`

const DivWrap = styled.div`
  width: 27.8%;
  width: 356px;
  position: relative;
  @media (max-width: 1280px) {
    width: 280px;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`
const OwnerSection = styled.section`
  background-color: #dae3e3;
  border-radius: 16px;
  text-align: center;
  padding: 35px 24px;
  width: 356px;
  @media (max-width: 1280px) {
    width: 280px;
  }
  @media (max-width: 768px) {
    margin-top: 18px;
    width: 100%;
  }
  .owner-head-text {
    font-size: 1.3rem;
  }
  .owner-image {
    width: 120px;
    height: 120px;
    border-radius: 60px;
    overflow: hidden;
    margin: 22px auto 0;
    background-size: cover;
    background-position: center;
  }
  .owner-name {
    font-weight: bold;
    font-size: 1.6rem;
    margin-top: 14px;
  }
  .owner-text {
    margin-top: 12px;
    margin-bottom: 24px;
    font-size: 1.4rem;
    text-align: left;
    font-weight: normal;
    @media (max-width: 768px) {
      padding: 0 15px;
    }
  }
  .owner-button {
    margin-top: 24px;
    color: #26bfdb;
    width: 100%;
    font-size: 1.4rem;
    height: 48px;
    border-radius: 24px;
    line-height: 48px;
    outline: 0px;
  }
`

const ScrollableDiv = styled.div`
  position: sticky;
  top: 120px;
  &.is-fixed {
    position: fixed;
    top: 230px;
    margin-top: 0;
    @media (max-width: 768px) {
      position: relative;
      top: 0;
      margin-top: 18px;
    }
  }
  &.is-stopped {
    position: absolute;
    bottom: 0;
    top: auto;
  }
  &.is-bottom {
    position: absolute;
    top: auto;
    bottom: 0;
    @media (max-width: 768px) {
      position: relative;
      margin-top: 18px;
    }
  }
`
